/**
 * If mobile it opens the navigation as sidebar, when clicking somewhere else
 * when the sidebar is open it hides automatically.
 */

const navbarInit = () => {
  const header: Element = document.querySelector('.header');
  const toggle: Element = header.querySelector('.header__menu-toggle');
  const dropdown: Element = header.querySelector('.header__menu-dropdown');

  toggle.addEventListener('click', () => {
    dropdown.classList.toggle('header__menu-dropdown--active');
    toggle.classList.toggle('header__menu-toggle--active');
  });
};

export default navbarInit;
